import { VehicleWidgetStore } from '../features/search/VehicleSearch/store/VehicleWidgetStore'

import { VehicleMakesStore } from '../features/search/VehicleSearch/store/VehicleMakesStore'
import { AstPunchOutStore } from './astPunchOut/AstPunchOutStore'
import { CustomizeSearchStore } from './customiseSearch/CustomizeSearchStore'
import { JobsCatalogStore } from './jobs/JobsStore'
import { LaborStore } from './labor/LaborStore'
import { PartsCatalogAPI } from './partsCatalog/api/PartsCatalogAPI'
import { PartsCatalog } from './partsCatalog/PartsCatalog'
import { BannerPromotionStore } from './promotion/BannerPromotionStore'
import { QuoteStore } from 'pages/quotes/src/store/QuoteStore'

import { SearchStore } from './search/SearchStore'
import { SpecificConditionsStore } from './specificConditions/SpecificConditionsStore'
import { UiStateStore } from './uiState/UiStateStore'
import { UserStore } from './user/UserStore'

let initialized = false

class StoreInstancesContainer {
  public uiStore: UiStateStore

  public searchStore: SearchStore

  public customizeSearchStore: CustomizeSearchStore

  public partsCatalog: PartsCatalog

  public laborStore: LaborStore

  public astPunchOutStore: AstPunchOutStore

  public specificConditions: SpecificConditionsStore

  public vehicleWidget: VehicleWidgetStore

  public vehicleMakesStore: VehicleMakesStore

  public userStore: UserStore

  public bannerPromotionStore: BannerPromotionStore

  public quoteStore: QuoteStore

  public jobsCatalog: JobsCatalogStore

  init = (): void => {
    if (initialized) {
      return
    }
    this.uiStore = new UiStateStore()
    this.partsCatalog = new PartsCatalog(new PartsCatalogAPI())
    this.laborStore = new LaborStore()
    this.astPunchOutStore = new AstPunchOutStore()
    this.searchStore = new SearchStore()
    this.specificConditions = new SpecificConditionsStore()
    this.userStore = new UserStore()
    this.customizeSearchStore = new CustomizeSearchStore()
    this.vehicleWidget = new VehicleWidgetStore()
    this.vehicleMakesStore = new VehicleMakesStore()
    this.bannerPromotionStore = new BannerPromotionStore()
    this.quoteStore = new QuoteStore()
    this.jobsCatalog = new JobsCatalogStore()
    this.searchStore.initReactions()
    initialized = true
  }
}

export const StoreInstances = new StoreInstancesContainer()
